
import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import EditCampaign from "layouts/Campaign/EditCampaign";

import routes from "routes.js";
import Auth from "./Auth";
import useToken from "auth/localStorage/tokenStorage";


const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

   

  const token = localStorage.getItem('token');
  if(!token) {
    return <Auth />
  }
  

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        if (prop.submenu && prop.submenu.length > 0) {
          // Render submenu routes
          const submenuRoutes = prop.submenu.map((submenuProp, submenuKey) => (
            <Route
              path={submenuProp.path}
              element={submenuProp.component}
              key={submenuKey}
              exact
            />
          ));
  
          return (
            <React.Fragment key={key}>
              <Route path={prop.path} element={prop.component} exact />
              {submenuRoutes}
            </React.Fragment>
          );
        } else {
          // Render single route
          return (
            <Route path={prop.path} element={prop.component} key={key} exact />
          );
        }
      } else {
        return null;
      }
    });
  };
  

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };



  
  return (
    <>

       <div className="min-height-400 bg-primary position-absolute w-100"></div>
      <Sidebar
        {...props}
        routes={routes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/pollpe_icon_only.png"),
          icon: require("../assets/img/brand/pollpe_logo_only.png"),
          imgAlt: "...",
        }}
      />
        <main className="main-content position-relative border-radius-lg  " ref={mainContent}>
    {/* <!-- Navbar --> */}
    
    <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
    {/* <!-- End Navbar --> */}
  
    <Routes>
          {getRoutes(routes)}
          <Route path="/campaign/edit/:id" element={<EditCampaign />} />
          <Route path="*" element={<Navigate to="/admin/index" replace />} />
         
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
  </main>
     
    </>
  );
};

export default Admin;
